export default __webpack_public_path__ + "static/media/bone-marrow.561e3258.jpg";